// extracted by mini-css-extract-plugin
export default {"afterpayBtnWrapper":"u7-z","button":"v7-z","disabled":"w7-z","creditCard":"x7-z","wrapper":"y7-z"};